import * as net from '~/lib/net';
import { getToken } from '~/apps/shared/services/token';
import { OrganizationEndpoints } from './endpoints';
import { OrganizationSchema, OrganizationListSchema } from './schemas';
import { Organization } from '../models';


export async function getOrganizationById(orgId): Promise<Organization> {
  const data = await net.apiGet(OrganizationEndpoints.getOrganizationById(orgId), getToken());
  return OrganizationSchema.load(data);
}

export async function getOrganizations(offset: number, limit: number): Promise<Organization[]> {
  const data = await net.apiGet(OrganizationEndpoints.getOrganizations(offset, limit), getToken());
  return OrganizationListSchema.load(data);
}

export async function findOrganizations(needle: string, orgType?: string): Promise<Organization[]> {
  const data = await net.apiGet(OrganizationEndpoints.findOrganizations(needle, orgType), getToken());
  return OrganizationListSchema.load(data);
}
